import { MessageBannerOptions } from '@com-delta-omnichannel/mach-core-js';
import { TextColorCodes } from '../interfaces/today.models';

export const enum Flyout {
  ONE = '1',
  MY_DELTA = 'Home',
  SEARCH_TYPE = 'confirmationInput',
  CONFIRMATION_NO = 'confirmationNo',
  TRIP_DETAILS_URL = '/my-trips/trip-details',
  TRIP_REQUEST = 'trip_request'
}

export const bannerOptions: MessageBannerOptions = {
  id: '',
  type: 'error',
  isSticky: false,
  hasBar: true,
  iconSize: 'small',
  content: {
    header: {
      title: '',
      hasCloseButton: false
    },
    description: ''
  }
};

export enum stickyBanner {
  msg_Banner = 'sticky-message-banner',
  err_Banner = 'sticky-error-banner',
  def_Banner = 'sticky-default-banner'
}

export enum Colors {
  YELLOW = 'YELLOW',
  GREEN = 'GREEN',
  RED = 'RED',
  ORANGE = 'ORANGE'
}

export enum Colors_s {
  green = 'green',
  red = 'red',
  orange = 'orange'
}

export enum Color_Codes {
  green = 'flight-status-green',
  red = 'flight-status-red',
  orange = 'flight-status-orange'
}

export enum MessageBannerType {
  INFORMATIONAL = 'informational',
  CONFIRMATION = 'confirmation',
  WARNING = 'warning',
  ERROR = 'error'
}
export const colorCodes: TextColorCodes = {
  GREEN: 'text-confirmation',
  ORANGE: 'text-notice',
  YELLOW: 'text-[#AB5300]',
  RED: 'text-alert'
};

export const IRPC_NO_PROT = 'IRPC_NO PROT';

export const IRPC_PROT = 'IRPC_PROT';

export const codes = {
  IRP_CLEAN_PAX: Color_Codes.green,
  IRPC_CLEAN_AUTO: Color_Codes.green,
  'IRPD_NO PROT_NO MISCONNECT': Color_Codes.orange,
  'IRPD_NO PROT_MISCONNECT': Color_Codes.orange,
  IRPD_PROT: Color_Codes.green,
  IRPD_CLEAN_AUTO: Color_Codes.green,
  IRPC_PROT: Color_Codes.green,
  'IRPC_NO PROT': Color_Codes.red,
  IRPC_NO_PROT: Color_Codes.red,
  IROP_EXC: Color_Codes.red,
  IROP_EXC_STN: Color_Codes.red
};
